import { FallbackPricingLink } from '@/constants';

export const LinkWrapperVariables: Record<string, string> = {
  CUSTOMER_DASHBOARD_URL: window.branding.customerDashboardUrl ?? '',
  CUSTOMER_SUPPORT_URL: window.branding.customerSupportUrl ?? '',
  CUSTOMER_SUPPORT_EMAIL: window.branding.customerSupportEmail ?? '',
};

export function replaceVariablesInLinkWrapper(
  url: string,
  variables: Record<string, string> = LinkWrapperVariables
): string {
  const trimLeadingSlashURL = url.startsWith('/${') ? url.slice(1) : url;
  if (window.branding.pricing) {
    window.branding.pricing.forEach(product => {
      LinkWrapperVariables[product.productName] = product.pricingUrl;
    });
  }
  const replacedText = Object.entries(variables).reduce(
    (text, [variable, value]) => text.replaceAll(`\${${variable}}`, value),
    trimLeadingSlashURL
  );
  const brand = window.branding.vendorId;
  return replacedText.replace(/\$\{.*?_(PRICING)}/gi, FallbackPricingLink[brand] ?? '');
}
